import { TrackingPageModel } from '../tracking-page.model';
import {
  getFontConfig,
  getFooterItems,
  getLogo,
  getAsset,
  getImage,
  getLanguageMenu,
  white,
  getProductItems,
  getSocialIcons
} from './helpers';

export const ratio: TrackingPageModel = {
  languageMenu: getLanguageMenu('Nunito', '#4a4a4aff'),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Nunito', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Nunito', '#4a4a4aff')
  },
  background: {
    color: '#faf9f6ff',
    useBackgroundImage: false,
    imageUrl: getImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#eb4f47ff',
    linksUnderline: false,
    backgroundColor: white,
    headerBackground: white,
    footerBackground: white,
    borderColor: '#cac8c2ff',
    borderRadius: 0,
    borderWidth: 2,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Nunito', '#4a4a4aff')
  },
  orderCard: {
    borderRadius: 0,
    borderWidth: 2,
    borderColor: '#cac8c2ff',
    backgroundColor: white,
    shadow: 'none',
    footerBackground: white,
    headerBackground: white,
    linksColor: '#eb4f47ff',
    linksUnderline: false,
    ...getFontConfig('Nunito', '#4a4a4aff')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Nunito', '#4a4a4aff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 20,
    ...getFontConfig('Nunito', '#4a4a4aff')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Nunito', '#bbbbbbff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Nunito', '#4a4a4aff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#cac8c2ff',
    borderRadius: 0,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#eb4f47ff',
      borderColor: '#e1c9b400',
      borderRadius: 0,
      borderWidth: 2,
      shadow: 'none',
      ...getFontConfig('Nunito', '#ffffffff')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: white,
      borderColor: '#cac8c2ff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 20,
        ...getFontConfig('Nunito', '#4a4a4aff')
      },
      info: {
        alignment: 'left',
        fontSize: 16,
        ...getFontConfig('Nunito', '#4a4a4aff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#00000000',
    borderColor: '#e1c9b4ff',
    borderRadius: 0,
    borderWidth: 2,
    shadow: 'none',
    ...getFontConfig('Nunito', '#000000ff')
  },
  detailsButton: {
    on: null,
    backgroundColor: '#eb4f47ff',
    borderColor: '#5780ff',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Nunito', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#eb4f47ff',
    borderColor: '#ee7227',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Nunito', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(
    getAsset(
      '/images/themes/5c98e7a851730_ratio-logo-dark-2x-9b7aab67-58f4-4fd4-88dc-756f62280b9d-x15-2x.png'
    )
  ),
  socialIcons: getSocialIcons('#e1c9b4ff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: white,
    borderColor: '#cac8c2ff',
    borderRadius: 0,
    borderWidth: 2,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Nunito', '#4a4a4aff')
  },
  footer: {
    linksColor: '#eb4f47ff',
    linksUnderline: false,
    backgroundColor: '#faf9f6ff',
    ...getFooterItems(),
    ...getFontConfig('Nunito', '#4A4A4A')
  },
  header: {
    backgroundColor: white
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#cac8c2ff',
    borderRadius: 0,
    borderWidth: 2,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#cac8c2ff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#eb4f47ff',
        borderColor: '#5780ff',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Nunito', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 11,
        ...getFontConfig('Nunito', '#4a4a4aff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Nunito', '#4a4a4aff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 18,
        ...getFontConfig('Nunito', '#4a4a4aff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#eb4f47ff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#cac8c2ff',
    borderRadius: 0,
    borderWidth: 2,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#cac8c2ff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#eb4f47ff',
        borderColor: '#5780ff',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Nunito', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 11,
        ...getFontConfig('Nunito', '#4a4a4aff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Nunito', '#4a4a4aff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 19,
        ...getFontConfig('Nunito', '#4a4a4aff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#eb4f47ff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
